export default "__VITE_ASSET__CsJCdCIX__"